module.exports = "/images/support-icon.svg?3f909c5aaf3abb95648625df27a1a0b8";